/**
 * Environment-specific configuration values.
 */
import { isLocalhostEnvironment } from '../utils/utils';
const ALL_CONFIG_VALUE_PROPERTIES = {
    tableGraphicsDelay: {
        defaultValue: 0
    }
};
export function getConfigValue(configValue) {
    const { defaultValue, localhostValue, liveValue } = ALL_CONFIG_VALUE_PROPERTIES[configValue];
    if (localhostValue !== undefined && isLocalhostEnvironment()) {
        return localhostValue;
    }
    if (liveValue !== undefined && !isLocalhostEnvironment()) {
        return liveValue;
    }
    return defaultValue;
}
